import { resolveEvidenceDisplayOrigin } from '../../../utils/evidence/evidenceDisplayOrigin';
import type { EvidenceOriginFields } from '../../../utils/evidence/evidenceDisplayOrigin';

/**
 * Discriminator for which body renderer to use for an evidence item.
 */
export type DiscoveryEvidenceBodyKind =
  | 'gong_call'
  | 'survey'
  | 'engagement_notes'
  | 'slack'
  | 'support_ticket'
  | 'productboard'
  | 'generic';

export function getDiscoveryEvidenceBodyKind(item: unknown): DiscoveryEvidenceBodyKind {
  const row = item as {
    cxItem?: {
      origin?: string;
      itemType?: string;
      businessCategory?: string;
    };
    origin?: string;
  };
  const cxItem = row?.cxItem;
  const cat = cxItem?.businessCategory;

  if (cat === 'call') return 'gong_call';
  if (cat === 'survey') return 'survey';
  if (cat === 'customerInterview') return 'engagement_notes';
  if (cat === 'chat') return 'slack';
  if (cat === 'ticket') return 'support_ticket';
  if (cat === 'request') return 'productboard';
  if (cat === 'generalFeedback' || cat === 'other') return 'generic';

  const origin =
    resolveEvidenceDisplayOrigin(row as EvidenceOriginFields) || row?.origin;

  const isEngagementNotes =
    cxItem?.itemType === 'other' && cxItem?.origin === 'salesforce';
  const isGongCall =
    ['gong', 'chorus', 'zoomInfo'].includes(String(origin)) ||
    cxItem?.itemType === 'call';
  const isSlackConversation = origin === 'slack';
  const isSupportTicket =
    cxItem?.businessCategory === 'ticket' && cxItem?.itemType === 'conversation';
  const isProductBoardTicket = origin === 'productboard';
  const isSurvey = cxItem?.businessCategory === 'survey';
  const isCall = cxItem?.businessCategory === 'call';

  if (isCall) return 'gong_call';
  if (isSurvey) return 'survey';
  if (isEngagementNotes) return 'engagement_notes';
  if (isSlackConversation) return 'slack';
  if (isSupportTicket) return 'support_ticket';
  if (isGongCall) return 'gong_call';
  if (isProductBoardTicket) return 'productboard';
  return 'generic';
}
